import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-16 md:py-24 bg-[#FAF8F5]" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6" data-id="element-15">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-16">
          {/* For Whom */}
          <div data-id="element-17">
            <h3 className="text-2xl font-bold text-[#44403C] mb-8 flex items-center gap-3" data-id="element-18">
              <span className="w-8 h-8 rounded-full bg-[#8B9D83] text-white flex items-center justify-center text-sm" data-id="element-19">
                ✓
              </span>
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-20">
              {['Estás cansada de adivinar qué provoca las alergias', "Quieres una casa limpia sin ese fuerte 'olor a perfume'", 'Necesitas un plan corto, realista y sostenible', 'Quieres sentir paz cuando tu hijo se acuesta a dormir'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-21">
                  <CheckCircle2 className="w-5 h-5 text-[#8B9D83] flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-[#57534E]" data-id="element-23">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For Whom */}
          <div data-id="element-24">
            <h3 className="text-2xl font-bold text-[#44403C] mb-8 flex items-center gap-3" data-id="element-25">
              <span className="w-8 h-8 rounded-full bg-[#C97D60] text-white flex items-center justify-center text-sm" data-id="element-26">
                ✕
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-27">
              {["Buscas promesas médicas o 'curas' milagrosas", 'Quieres fabricar TODO desde cero con 40 ingredientes raros', 'No estás dispuesta a cambiar tu detergente (aunque sea un poco)', 'Buscas una solución química industrial rápida'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-28">
                  <XCircle className="w-5 h-5 text-[#C97D60] flex-shrink-0 mt-0.5" data-id="element-29" />
                  <span className="text-[#57534E]" data-id="element-30">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}